
import { getNonEmpty } from '../../../../utils/helpers';
import EditIcon from "@material-ui/icons/Edit";
import { buttonsStyle } from "../../../components/tables/table";
import {
    Button,
    Tooltip
} from "@material-ui/core";
import { shallowEqual, useSelector } from "react-redux";
import { ArrowUpward, ArrowDownward } from "@material-ui/icons";
import DeleteIcon from "@material-ui/icons/Delete";
import { NewTable } from "../customers/EditCustomerPage";

export default function TablePlan({ data, setData, setFeatureSelected, setFeaturesOpen, tableKey, setTableKey }) {
    const user = useSelector((store) => store.authentication?.user, shallowEqual);


    function buttonFormatter(elem) {
        const currentIndex = data.findIndex((item) => item.order === elem.order);
        const canMoveUp = currentIndex > 0;
        const canMoveDown = currentIndex < data.length - 1;

        const swapItems = (from, to) => {
            const updatedData = [...data];
            const temp = updatedData[from];
            updatedData[from] = updatedData[to];
            updatedData[to] = temp;

            const reordered = updatedData.map((item, index) => ({
                ...item,
                order: index,
            }));

            setData(reordered);
            setTableKey(k => k + 1);
        };

        return (
            <>
                <Tooltip title="Edit">
                    <Button
                        style={buttonsStyle}
                        size="small"
                        onClick={() => {
                            setFeatureSelected(elem)
                            setFeaturesOpen(true)
                        }
                        }
                    >
                        <EditIcon />
                    </Button>
                </Tooltip>
                {user?.role === "admin" && (
                    <>
                        <Tooltip title="Delete">
                            <Button
                                style={buttonsStyle}
                                size="small"
                                onClick={() => {
                                    const updatedData = data
                                        .filter(item => item.order !== elem.order)
                                        .map((item, index) => ({
                                            ...item,
                                            order: index + 1,
                                        }));
                                    setData([...updatedData]);
                                    setTableKey(k => k + 1);
                                }}
                            >
                                <DeleteIcon />
                            </Button>
                        </Tooltip>
                    </>
                )}
                {canMoveUp && (
                    <Tooltip title="Move Up">
                        <Button
                            style={buttonsStyle}
                            size="small"
                            onClick={() => swapItems(currentIndex, currentIndex - 1)}
                        >
                            <ArrowUpward />
                        </Button>
                    </Tooltip>
                )}
                {canMoveDown && (
                    <Tooltip title="Move Down">
                        <Button
                            style={buttonsStyle}
                            size="small"
                            onClick={() => swapItems(currentIndex, currentIndex + 1)}
                        >
                            <ArrowDownward />
                        </Button>
                    </Tooltip>
                )}
            </>
        );
    }

    const columns = [
        { dataField: "title", text: "Title", formatter: (cell, row) => getNonEmpty(row.title) },
        { dataField: "order", text: "", formatter: (_, row) => buttonFormatter(row), headerStyle: { width: '200px' } },
    ];


    return (
        <>
            <div className="col-12">
                <NewTable key={tableKey} data={data} columns={columns} />
            </div>
        </>
    );


}